import React, { useContext } from 'react';
import LoginCard from './components/LoginCard';
import QRCodeDisplay from './components/QRCodeDisplay';
import { QRCodeContext, QRCodeProvider } from './context';

const AppContent = () => {
  const { state } = useContext(QRCodeContext);
  const { qrCode, uid, online } = state;

  return (
    <>
      {uid && <QRCodeDisplay base64Image={qrCode} accountId={uid} isOnline={online !== undefined} />}
      {!uid && <LoginCard />}
    </>
  );
};


const App = () => {
  return (
    <QRCodeProvider>
      <AppContent />
    </QRCodeProvider>
  );
};

export default App;
